<!-- Note Add/Edit/View Modal -->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '800px', maxWidth: '95vw', maxHeight: '90vh' }"
  [header]="dialogHeader"
  [styleClass]="'note-form-dialog'"
  (onHide)="closed.emit()"
>
  <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
    <!-- Created by / date created: provenance of an existing note, read-only and not editable -->
    <div
      class="note-created-meta"
      *ngIf="editNote.id && (editNote.createdByUserName || editNote.dateCreatedUtc)"
    >
      <span *ngIf="editNote.createdByUserName">Created By: {{ editNote.createdByUserName }}</span>
      <span *ngIf="editNote.dateCreatedUtc"
        >Date Created: {{ formatUpdateDate(editNote.dateCreatedUtc) }}</span
      >
    </div>

    <div class="form-group">
      <label>Type <span class="text-danger" *ngIf="!readOnly">*</span></label>
      <select
        class="form-control"
        [(ngModel)]="editNote.type"
        (ngModelChange)="onNoteTypeChange()"
        [disabled]="readOnly"
      >
        <option value="">--Select Type--</option>
        <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Status</label>
      <select class="form-control" [(ngModel)]="editNote.status" [disabled]="readOnly">
        <option value="Open">Open</option>
        <option value="Resolved">Resolved</option>
      </select>
    </div>

    <div class="form-group">
      <label>Driver</label>
      <div *ngIf="driver" class="form-control-static">
        {{ driverDisplayName }}
        <span class="driver-team-list" *ngIf="driverTeamMembersText">
          <i class="fa fa-users"></i> {{ driverTeamMembersText }}
        </span>
      </div>
      <div *ngIf="!driver && editNote.driverName" class="form-control-static">
        {{ editNote.driverName }}
        <span class="driver-team-list" *ngIf="driverTeamMembersText">
          <i class="fa fa-users"></i> {{ driverTeamMembersText }}
        </span>
      </div>
      <select
        *ngIf="!driver && !editNote.driverName"
        class="form-control"
        [(ngModel)]="editNote.driverId"
        (ngModelChange)="onDriverSelectChange()"
        [disabled]="readOnly || !!editNote.id"
      >
        <option value="">--Select Driver--</option>
        <option *ngFor="let d of drivers" [value]="d.id">{{ d.lastName }} {{ d.name }}</option>
      </select>
      <div
        class="driver-team-list"
        *ngIf="!driver && !editNote.driverName && editNote.driverId && driverTeamMembersText"
      >
        <i class="fa fa-users"></i> {{ driverTeamMembersText }}
      </div>
    </div>

    <div class="form-group">
      <label>Follow-up Date</label>
      <input
        type="text"
        class="form-control"
        [inputMask]="dateInputMask"
        placeholder="MM/DD/YYYY"
        [(ngModel)]="editNote.followUpDate"
        [disabled]="readOnly"
      />
      <small class="form-text text-muted" *ngIf="!readOnly"
        >Optional - set a reminder to follow up on this note</small
      >
    </div>

    <!-- Common Note Field -->
    <div
      class="form-group"
      *ngIf="
        editNote.type &&
        !isAccidentOrIncident(editNote.type) &&
        !isDelayOrBreakdown(editNote.type) &&
        !isDriverRelease(editNote.type)
      "
    >
      <label>Note <span class="text-danger" *ngIf="!readOnly">*</span></label>
      <textarea
        class="form-control"
        [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.note }"
        [(ngModel)]="editNote.note"
        rows="4"
        placeholder="Enter note text..."
        [disabled]="readOnly"
      ></textarea>
      <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.note">Note is required</div>
    </div>

    <!-- Complaint: internal user tag -->
    <div class="form-group" *ngIf="isComplaint(editNote.type)">
      <label>Tagged Internal User</label>
      <select *ngIf="!readOnly" class="form-control" [(ngModel)]="editNote.taggedUserId">
        <option value="">--None--</option>
        <option *ngFor="let u of taggableUsers" [value]="u.id">{{ u.name }}</option>
      </select>
      <div *ngIf="readOnly" class="form-control-static">{{ editNote.taggedUserName || "-" }}</div>
    </div>

    <!-- Accident/Incident Fields -->
    <div *ngIf="isAccidentOrIncident(editNote.type)">
      <h5 class="section-header">Accident/Incident Details</h5>

      <!-- Yes to any of the first three questions means Safety has to be called, so every
           question that is answered Yes carries its own warning right under it. -->
      <div class="form-group">
        <label
          >Any Injuries, Tow aways, or Fatalities?
          <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <div
          class="radio-group"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit &&
              (editNote.anyInjuries === undefined || editNote.anyInjuries === null),
          }"
        >
          <label class="radio-inline">
            <input
              type="radio"
              name="anyInjuries"
              [value]="false"
              [ngModel]="editNote.anyInjuries"
              (ngModelChange)="onAnyInjuriesChange($event)"
              [disabled]="readOnly"
            />
            No
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="anyInjuries"
              [value]="true"
              [ngModel]="editNote.anyInjuries"
              (ngModelChange)="onAnyInjuriesChange($event)"
              [disabled]="readOnly"
            />
            Yes
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            attemptedSubmit && (editNote.anyInjuries === undefined || editNote.anyInjuries === null)
          "
        >
          This field is required
        </div>
        <!-- Yes means at least one of the three applies; any combination is allowed. -->
        <div
          class="checkbox-group"
          [ngClass]="{
            'is-invalid': attemptedSubmit && editNote.anyInjuries === true && !hasInjuriesDetails,
          }"
          *ngIf="editNote.anyInjuries && (!readOnly || hasInjuriesDetails)"
        >
          <label class="checkbox-inline">
            <input
              type="checkbox"
              name="hasInjuries"
              [(ngModel)]="editNote.hasInjuries"
              [disabled]="readOnly"
            />
            Injuries
          </label>
          <label class="checkbox-inline">
            <input
              type="checkbox"
              name="hasTowAway"
              [(ngModel)]="editNote.hasTowAway"
              [disabled]="readOnly"
            />
            Tow away
          </label>
          <label class="checkbox-inline">
            <input
              type="checkbox"
              name="hasFatality"
              [(ngModel)]="editNote.hasFatality"
              [disabled]="readOnly"
            />
            Fatality
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="attemptedSubmit && editNote.anyInjuries === true && !hasInjuriesDetails"
        >
          Select at least one of Injuries, Tow away, or Fatality
        </div>
        <div *ngIf="!readOnly && editNote.anyInjuries" class="alert alert-warning mt-2">
          <strong>IMPORTANT:</strong> Call the safety director IMMEDIATELY.
        </div>
      </div>

      <!-- Optional free text for a Yes answer. Hidden in view mode unless something was saved. -->
      <div
        class="form-group"
        *ngIf="editNote.anyInjuries && (!readOnly || editNote.injuriesDescription)"
      >
        <label>Injury / Tow away / Fatality Details</label>
        <textarea
          class="form-control"
          [(ngModel)]="editNote.injuriesDescription"
          rows="2"
          placeholder="Add any details (optional)"
          [disabled]="readOnly"
        ></textarea>
      </div>

      <div class="form-group">
        <label
          >Is another vehicle involved? <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <div
          class="radio-group"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit &&
              (editNote.anotherVehicleInvolved === undefined ||
                editNote.anotherVehicleInvolved === null),
          }"
        >
          <label class="radio-inline">
            <input
              type="radio"
              name="anotherVehicle"
              [value]="false"
              [(ngModel)]="editNote.anotherVehicleInvolved"
              [disabled]="readOnly"
            />
            No
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="anotherVehicle"
              [value]="true"
              [(ngModel)]="editNote.anotherVehicleInvolved"
              [disabled]="readOnly"
            />
            Yes
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            attemptedSubmit &&
            (editNote.anotherVehicleInvolved === undefined ||
              editNote.anotherVehicleInvolved === null)
          "
        >
          This field is required
        </div>
        <div *ngIf="!readOnly && editNote.anotherVehicleInvolved" class="alert alert-warning mt-2">
          <strong>IMPORTANT:</strong> Call the safety director IMMEDIATELY.
        </div>
      </div>

      <!-- Optional free text for a Yes answer. Hidden in view mode unless something was saved. -->
      <div
        class="form-group"
        *ngIf="editNote.anotherVehicleInvolved && (!readOnly || editNote.anotherVehicleDescription)"
      >
        <label>Another Vehicle Details</label>
        <textarea
          class="form-control"
          [(ngModel)]="editNote.anotherVehicleDescription"
          rows="2"
          placeholder="Add any details (optional)"
          [disabled]="readOnly"
        ></textarea>
      </div>

      <div class="form-group">
        <label
          >Is our driver receiving a citation?
          <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <div
          class="radio-group"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit &&
              (editNote.driverCitation === undefined || editNote.driverCitation === null),
          }"
        >
          <label class="radio-inline">
            <input
              type="radio"
              name="citation"
              [value]="false"
              [(ngModel)]="editNote.driverCitation"
              [disabled]="readOnly"
            />
            No
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="citation"
              [value]="true"
              [(ngModel)]="editNote.driverCitation"
              [disabled]="readOnly"
            />
            Yes
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            attemptedSubmit &&
            (editNote.driverCitation === undefined || editNote.driverCitation === null)
          "
        >
          This field is required
        </div>
        <div *ngIf="!readOnly && editNote.driverCitation" class="alert alert-warning mt-2">
          <strong>IMPORTANT:</strong> Call the safety director IMMEDIATELY.
        </div>
      </div>

      <div class="form-group" *ngIf="editNote.driverCitation">
        <label>Citation Description <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <textarea
          class="form-control"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit && editNote.driverCitation && !editNote.citationDescription,
          }"
          [(ngModel)]="editNote.citationDescription"
          rows="2"
          [disabled]="readOnly"
        ></textarea>
        <div
          class="invalid-feedback"
          *ngIf="attemptedSubmit && editNote.driverCitation && !editNote.citationDescription"
        >
          Citation description is required
        </div>
      </div>

      <div class="row" *ngIf="driver">
        <div class="col-md-12 form-group">
          <label>Driver</label>
          <div>
            {{ driver.name }} {{ driver.lastName }}
            <span class="driver-team-list" *ngIf="driverTeamMembersText">
              <i class="fa fa-users"></i> {{ driverTeamMembersText }}
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Tractor <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.tractorId }"
            [(ngModel)]="editNote.tractorId"
            [disabled]="readOnly"
          >
            <option value="">--Select Tractor--</option>
            <option *ngFor="let tractor of tractors" [value]="tractor.id">
              {{ tractor.itemName || tractor.unitNumber }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.tractorId">
            Tractor is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Trailer <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.trailerId }"
            [(ngModel)]="editNote.trailerId"
            [disabled]="readOnly"
          >
            <option value="">--Select Trailer--</option>
            <option *ngFor="let trailer of trailers" [value]="trailer.id">
              {{ trailer.trailerNo }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.trailerId">
            Trailer is required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Shipper Trailer Information</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="editNote.shipperTrailerInformation"
          [disabled]="readOnly"
        />
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Loaded/Empty <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.loadedEmpty }"
            [(ngModel)]="editNote.loadedEmpty"
            [disabled]="readOnly"
          >
            <option value="">--Select--</option>
            <option value="Loaded">Loaded</option>
            <option value="Empty">Empty</option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.loadedEmpty">
            Loaded/Empty is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Product <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.productId }"
            [(ngModel)]="editNote.productId"
            [disabled]="readOnly"
          >
            <option value="">--Select Product--</option>
            <option *ngFor="let product of products" [value]="product.id">
              {{ product.name }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.productId">
            Product is required
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group">
          <label>Date of Accident <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <input
            type="date"
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentDate }"
            [(ngModel)]="editNote.accidentDate"
            [disabled]="readOnly"
          />
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentDate">
            Date of accident is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          <label>Time of Accident <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <input
            type="time"
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentTime }"
            [(ngModel)]="editNote.accidentTime"
            [disabled]="readOnly"
          />
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentTime">
            Time of accident is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          <label>Time Zone <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.timeZone }"
            [(ngModel)]="editNote.timeZone"
            [disabled]="readOnly"
          >
            <option value="">--Select Time Zone--</option>
            <option *ngFor="let zone of timeZoneOptions" [value]="zone">{{ zone }}</option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.timeZone">
            Time zone is required
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>City <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <input
            type="text"
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentCity }"
            [(ngModel)]="editNote.accidentCity"
            [disabled]="readOnly"
          />
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentCity">
            City is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>State <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentState }"
            [(ngModel)]="editNote.accidentState"
            [disabled]="readOnly"
          >
            <option value="">--Select State--</option>
            <option *ngFor="let state of states" [value]="state.abbreviation">
              {{ state.abbreviation }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentState">
            State is required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Accident Location <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentLocation }"
          [(ngModel)]="editNote.accidentLocation"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentLocation">
          Accident location is required
        </div>
      </div>

      <div class="form-group">
        <label>Weather <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <p-autoComplete
          [(ngModel)]="editNote.weather"
          [suggestions]="filteredWeatherValues"
          (completeMethod)="filterWeatherValues($event)"
          [dropdown]="true"
          [forceSelection]="false"
          placeholder="e.g., Dry, Rainy, Foggy"
          styleClass="weather-autocomplete"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.weather }"
          [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"
          [inputStyleClass]="attemptedSubmit && !editNote.weather ? 'is-invalid' : ''"
          [disabled]="readOnly"
        ></p-autoComplete>
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.weather">
          Weather is required
        </div>
      </div>

      <div class="form-group">
        <label>Description of Accident <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <textarea
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.accidentDescription }"
          [(ngModel)]="editNote.accidentDescription"
          rows="3"
          [disabled]="readOnly"
        ></textarea>
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.accidentDescription">
          Description of accident is required
        </div>
      </div>

      <div class="form-group">
        <label>Description of Damage <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <textarea
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.damageDescription }"
          [(ngModel)]="editNote.damageDescription"
          rows="3"
          [disabled]="readOnly"
        ></textarea>
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.damageDescription">
          Description of damage is required
        </div>
      </div>

      <div class="form-group">
        <label>Assigned Customer <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.assignedCustomer }"
          [(ngModel)]="editNote.assignedCustomer"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.assignedCustomer">
          Assigned customer is required
        </div>
      </div>

      <div class="form-group">
        <label>Photos to Safety <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.photosToSafety }"
          [(ngModel)]="editNote.photosToSafety"
          placeholder="Yes/No and details"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.photosToSafety">
          Photos to safety is required
        </div>
      </div>

      <div class="form-group">
        <label
          >Have they spoken with their assigned customer, or any other third parties?
          <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <div
          class="radio-group"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit &&
              (editNote.spokenWithThirdParty === undefined ||
                editNote.spokenWithThirdParty === null),
          }"
        >
          <label class="radio-inline">
            <input
              type="radio"
              name="spokenWithThirdParty"
              [value]="false"
              [(ngModel)]="editNote.spokenWithThirdParty"
              [disabled]="readOnly"
            />
            No
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="spokenWithThirdParty"
              [value]="true"
              [(ngModel)]="editNote.spokenWithThirdParty"
              [disabled]="readOnly"
            />
            Yes
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            attemptedSubmit &&
            (editNote.spokenWithThirdParty === undefined || editNote.spokenWithThirdParty === null)
          "
        >
          This field is required
        </div>
      </div>

      <div class="form-group" *ngIf="editNote.spokenWithThirdParty">
        <label>Did they get a name?</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="editNote.thirdPartyContactName"
          placeholder="Contact name (if obtained)"
          [disabled]="readOnly"
        />
      </div>
    </div>

    <!-- Delay/Breakdown Fields -->
    <div *ngIf="isDelayOrBreakdown(editNote.type)">
      <h5 class="section-header">Delay/Breakdown Details</h5>

      <div class="form-group" *ngIf="driver">
        <label>Driver</label>
        <div>
          {{ driver.name }} {{ driver.lastName }}
          <span class="driver-team-list" *ngIf="driverTeamMembersText">
            <i class="fa fa-users"></i> {{ driverTeamMembersText }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Start Date</label>
          <p-calendar
            [(ngModel)]="editNote.startDate"
            dateFormat="mm/dd/yy"
            [showIcon]="true"
            [showOnFocus]="false"
            [appendTo]="'body'"
            placeholder="SELECT START DATE"
            [disabled]="readOnly"
          ></p-calendar>
        </div>
        <div class="col-md-6 form-group">
          <label>
            End Date
            <span class="text-danger" *ngIf="resolvedBreakdownMissingEndDate">*</span>
          </label>
          <p-calendar
            [(ngModel)]="editNote.endDate"
            dateFormat="mm/dd/yy"
            [showIcon]="true"
            [showOnFocus]="false"
            [appendTo]="'body'"
            placeholder="SELECT END DATE"
            [disabled]="readOnly"
            [class.is-invalid]="
              attemptedSubmit && (resolvedBreakdownMissingEndDate || endDateBeforeStartDate)
            "
          ></p-calendar>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && endDateBeforeStartDate">
            End Date must be on or after the Start Date
          </div>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && resolvedBreakdownMissingEndDate">
            End Date is required to mark this breakdown note as Resolved
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Client <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.clientId }"
            [(ngModel)]="editNote.clientId"
            (ngModelChange)="onClientChange()"
            [disabled]="readOnly"
          >
            <option value="">--Select Client--</option>
            <option *ngFor="let client of clients" [value]="client.id">
              {{ client.companyName }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.clientId">
            Client is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Bill To <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.billToId }"
            [(ngModel)]="editNote.billToId"
            [disabled]="!editNote.clientId || readOnly"
          >
            <option value="">--Select Bill To--</option>
            <option *ngFor="let billTo of filteredBillTos" [value]="billTo.id">
              {{ billTo.companyName }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.billToId">
            Bill To is required
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Trip Number</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="editNote.tripNumber"
            [disabled]="readOnly"
          />
        </div>
        <div class="col-md-6 form-group">
          <label>Customer Reference #</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="editNote.customerReferenceNumber"
            [disabled]="readOnly"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>ETA <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <div class="eta-input-row">
            <div class="eta-calendar">
              <p-calendar
                [(ngModel)]="editNote.eta"
                dateFormat="mm/dd/yy"
                [showTime]="true"
                [showIcon]="true"
                [showOnFocus]="false"
                [appendTo]="'body'"
                hourFormat="12"
                placeholder="SELECT ETA DATE/TIME"
                [styleClass]="
                  attemptedSubmit && !editNote.eta && !etaUnknown ? 'ng-invalid ng-dirty' : ''
                "
                [disabled]="readOnly || etaUnknown"
              ></p-calendar>
            </div>
            <label class="eta-unknown-label">
              Unknown ETA
              <input
                type="checkbox"
                [(ngModel)]="etaUnknown"
                (ngModelChange)="onEtaUnknownChange()"
                [disabled]="readOnly"
              />
            </label>
          </div>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.eta && !etaUnknown">
            ETA is required
          </div>
        </div>
        <div class="col-md-6 form-group" *ngIf="isBreakdown(editNote.type)">
          <label>Truck/Trailer Issue <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.truckTrailerIssue }"
            [(ngModel)]="editNote.truckTrailerIssue"
            [disabled]="readOnly"
          >
            <option value="">--Select--</option>
            <option *ngFor="let option of truckTrailerIssueOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.truckTrailerIssue">
            Truck/Trailer issue is required
          </div>
        </div>
      </div>

      <!-- Breakdown equipment: which unit is out of service. Optional - it is filled in from
           the driver's current assignment, and the dashboard's Tractor / Trailer column shows it. -->
      <div class="row" *ngIf="isBreakdown(editNote.type)">
        <div class="col-md-6 form-group">
          <label>Tractor</label>
          <select class="form-control" [(ngModel)]="editNote.tractorId" [disabled]="readOnly">
            <option value="">--Select Tractor--</option>
            <option *ngFor="let tractor of tractors" [value]="tractor.id">
              {{ tractor.itemName || tractor.unitNumber }}
            </option>
          </select>
        </div>
        <div class="col-md-6 form-group">
          <label>Trailer</label>
          <select class="form-control" [(ngModel)]="editNote.trailerId" [disabled]="readOnly">
            <option value="">--Select Trailer--</option>
            <option *ngFor="let trailer of trailers" [value]="trailer.id">
              {{ trailer.trailerNo }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Loaded/Empty <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <select
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.loadedEmpty }"
            [(ngModel)]="editNote.loadedEmpty"
            [disabled]="readOnly"
          >
            <option value="">--Select--</option>
            <option value="Loaded">Loaded</option>
            <option value="Empty">Empty</option>
          </select>
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.loadedEmpty">
            Loaded/Empty is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label>Product</label>
          <select class="form-control" [(ngModel)]="editNote.productId" [disabled]="readOnly">
            <option value="">--Select Product--</option>
            <option *ngFor="let product of products" [value]="product.id">
              {{ product.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>HOS Remaining</label>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="editNote.hosRemaining"
            placeholder="Hours"
            step="0.5"
            [disabled]="readOnly"
          />
        </div>
        <div class="col-md-6 form-group" *ngIf="isBreakdown(editNote.type)">
          <label>Road Call Number <span class="text-danger" *ngIf="!readOnly">*</span></label>
          <input
            type="text"
            class="form-control"
            [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.roadCallNumber }"
            [(ngModel)]="editNote.roadCallNumber"
            [disabled]="readOnly"
          />
          <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.roadCallNumber">
            Road call number is required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Internal Notes</label>
        <textarea
          class="form-control"
          [(ngModel)]="editNote.internalNotes"
          rows="3"
          [disabled]="readOnly"
        ></textarea>
      </div>

      <div class="form-group">
        <label>Client Notes <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <textarea
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.clientNotes }"
          [(ngModel)]="editNote.clientNotes"
          rows="3"
          [disabled]="readOnly"
        ></textarea>
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.clientNotes">
          Client notes are required
        </div>
      </div>
    </div>

    <!-- Driver Release Fields -->
    <div *ngIf="isDriverRelease(editNote.type)">
      <h5 class="section-header">Driver Release Details</h5>

      <div class="form-group" *ngIf="driver">
        <label>Driver</label>
        <div>
          {{ driver.name }} {{ driver.lastName }}
          <span class="driver-team-list" *ngIf="driverTeamMembersText">
            <i class="fa fa-users"></i> {{ driverTeamMembersText }}
          </span>
        </div>
      </div>

      <div class="form-group">
        <label>Where are they located? <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.driverLocation }"
          [(ngModel)]="editNote.driverLocation"
          placeholder="Enter current location"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.driverLocation">
          Location is required
        </div>
      </div>

      <div class="form-group">
        <label
          >Are they loaded or empty? <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <select
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.loadedEmpty }"
          [(ngModel)]="editNote.loadedEmpty"
          [disabled]="readOnly"
        >
          <option value="">--Select--</option>
          <option value="Loaded">Loaded</option>
          <option value="Empty">Empty</option>
        </select>
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.loadedEmpty">
          Loaded/Empty is required
        </div>
      </div>

      <div class="form-group">
        <label>Product</label>
        <select class="form-control" [(ngModel)]="editNote.productId" [disabled]="readOnly">
          <option value="">--Select Product--</option>
          <option *ngFor="let product of products" [value]="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Do they want time off? <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <div
          class="radio-group"
          [ngClass]="{
            'is-invalid':
              attemptedSubmit &&
              (editNote.requestTimeOff === undefined || editNote.requestTimeOff === null),
          }"
        >
          <label class="radio-inline">
            <input
              type="radio"
              name="requestTimeOff"
              [value]="false"
              [(ngModel)]="editNote.requestTimeOff"
              [disabled]="readOnly"
            />
            No
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="requestTimeOff"
              [value]="true"
              [(ngModel)]="editNote.requestTimeOff"
              [disabled]="readOnly"
            />
            Yes
          </label>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            attemptedSubmit &&
            (editNote.requestTimeOff === undefined || editNote.requestTimeOff === null)
          "
        >
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label>Trailer dropoff location <span class="text-danger" *ngIf="!readOnly">*</span></label>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.trailerDropoffLocation }"
          [(ngModel)]="editNote.trailerDropoffLocation"
          placeholder="Enter trailer dropoff location"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.trailerDropoffLocation">
          Trailer dropoff location is required
        </div>
      </div>

      <div class="form-group">
        <label
          >When are they next available? <span class="text-danger" *ngIf="!readOnly">*</span></label
        >
        <input
          type="text"
          class="form-control"
          [ngClass]="{ 'is-invalid': attemptedSubmit && !editNote.nextAvailable }"
          [(ngModel)]="editNote.nextAvailable"
          placeholder="E.G., TOMORROW 8 AM"
          [disabled]="readOnly"
        />
        <div class="invalid-feedback" *ngIf="attemptedSubmit && !editNote.nextAvailable">
          Next available date/time is required
        </div>
      </div>
    </div>

    <!-- Status Updates (any note type) -->
    <ng-container *ngIf="editNote.id">
      <div class="note-updates-block">
        <h5 class="section-header">
          Status Updates
          <span *ngIf="hasUpdates" class="badge badge-secondary update-count-badge">
            {{ editNote.updates?.length }}
          </span>
        </h5>

        <div *ngIf="hasUpdates" class="note-updates-list">
          <div *ngFor="let update of editNote.updates" class="note-update-item">
            <div class="note-update-head">
              <span class="note-update-label">{{ update.label || "Update" }}</span>
              <span class="note-update-meta">
                {{ formatUpdateDate(update.dateCreatedUtc) }}
                <ng-container *ngIf="update.createdByUserName">
                  &middot; {{ update.createdByUserName }}
                </ng-container>
                <i
                  *ngIf="update.emailedToClient"
                  class="fa fa-envelope text-success ml-1"
                  title="Emailed to client"
                ></i>
                <i
                  *ngIf="update.emailedToDriver"
                  class="fa fa-envelope text-info ml-1"
                  title="Emailed to driver"
                ></i>
              </span>
            </div>
            <div *ngIf="update.internalNotes" class="note-update-text note-update-internal">
              <span class="note-update-tag">Internal</span>
              {{ update.internalNotes }}
            </div>
            <div *ngIf="update.clientNotes" class="note-update-text note-update-client">
              <span class="note-update-tag">Public</span>
              {{ update.clientNotes }}
            </div>
            <div class="note-update-actions" *ngIf="!readOnly">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="startEditUpdate(update)"
                title="Edit update"
              >
                <i class="fa fa-pencil"></i> Edit
              </button>
              <button
                type="button"
                class="btn btn-info btn-sm"
                *ngIf="canEmailClient(editNote.type)"
                (click)="emailUpdateToClient(update)"
                [disabled]="!emailFeaturesEnabled"
                title="Email this update to the client"
              >
                <i class="fa fa-envelope"></i> Email Client
                <i class="fa fa-check text-success ml-1" *ngIf="update.emailedToClient"></i>
              </button>
              <button
                type="button"
                class="btn btn-info btn-sm"
                *ngIf="canEmailDriver(editNote.type)"
                (click)="emailUpdateToDriver(update)"
                [disabled]="!driver?.id"
                title="Email this update to the driver"
              >
                <i class="fa fa-envelope"></i> Email Driver
                <i class="fa fa-check text-success ml-1" *ngIf="update.emailedToDriver"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger btn-sm"
                (click)="deleteUpdate(update)"
                title="Delete update"
              >
                <i class="fa fa-trash"></i> Delete
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="!hasUpdates && !readOnly" class="text-muted small mb-2">No updates yet.</div>

        <button
          *ngIf="!readOnly && !showAddUpdate"
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="openAddUpdate()"
        >
          <i class="fa fa-plus"></i> Add Update
        </button>

        <div *ngIf="!readOnly && showAddUpdate" class="note-update-add">
          <h6 class="text-muted" *ngIf="editingUpdateId">Edit Update</h6>
          <div class="form-group">
            <label>Update Label (optional)</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="addUpdate.label"
              placeholder="e.g. Called customer, Parts ordered, Completed"
            />
          </div>
          <div class="form-group">
            <label>Internal Notes</label>
            <textarea
              class="form-control"
              [(ngModel)]="addUpdate.internalNotes"
              rows="2"
              placeholder="Internal only - never leaves LGT"
            ></textarea>
          </div>
          <div class="form-group">
            <label>Public Notes</label>
            <textarea
              class="form-control"
              [ngClass]="{ 'is-invalid': updateAttemptedSubmit && !isAddUpdateValid() }"
              [(ngModel)]="addUpdate.clientNotes"
              rows="2"
              placeholder="Can be emailed to the client or the driver"
            ></textarea>
          </div>
          <div class="button-group">
            <button type="button" class="btn btn-secondary btn-sm" (click)="cancelAddUpdate()">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="saveUpdate()"
              [disabled]="isSavingUpdate"
            >
              <i class="fa fa-spin fa-spinner" *ngIf="isSavingUpdate"></i>
              {{
                isSavingUpdate ? "Saving\u2026" : editingUpdateId ? "Save Changes" : "Save Update"
              }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeModal()">
        {{ readOnly ? "Close" : "Cancel" }}
      </button>

      <!-- Email buttons for existing notes (edit mode only) -->
      <div
        *ngIf="!readOnly && !hideEmailButtons && editNote.id && isAccidentOrIncident(editNote.type)"
        class="d-inline-block ml-2"
      >
        <button
          class="btn btn-info"
          (click)="emailToSafety()"
          [disabled]="!driver?.id || !emailFeaturesEnabled"
          title="Email to Safety"
        >
          <i class="fa fa-envelope"></i> Email Safety
          <i class="fa fa-check text-success ml-1" *ngIf="editNote.emailedToSafety"></i>
        </button>
        <button
          class="btn btn-info ml-1"
          (click)="emailFormToDriver()"
          [disabled]="!driver?.id"
          title="Email Form to Driver"
        >
          <i class="fa fa-envelope"></i> Email Form
          <i class="fa fa-check text-success ml-1" *ngIf="editNote.emailedFormToDriver"></i>
        </button>
      </div>

      <div
        *ngIf="!readOnly && !hideEmailButtons && editNote.id && canEmailClient(editNote.type)"
        class="d-inline-block ml-2"
      >
        <button
          class="btn btn-info"
          (click)="emailToClient()"
          [disabled]="!driver?.id || !emailFeaturesEnabled"
          title="Email to Client"
        >
          <i class="fa fa-envelope"></i> Email Client
          <i class="fa fa-check text-success ml-1" *ngIf="editNote.emailedToClient"></i>
        </button>
        <button
          *ngIf="canEmailDriver(editNote.type)"
          class="btn btn-info ml-1"
          (click)="emailToDriver()"
          [disabled]="!driver?.id"
          title="Email to Driver"
        >
          <i class="fa fa-envelope"></i> Email Driver
          <i class="fa fa-check text-success ml-1" *ngIf="editNote.emailedToDriver"></i>
        </button>
      </div>

      <button
        *ngIf="!readOnly"
        class="btn btn-primary ml-2"
        (click)="saveNote()"
        [disabled]="
          !editNote.driverId ||
          !editNote.type ||
          (!editNote.note &&
            !isAccidentOrIncident(editNote.type) &&
            !isDelayOrBreakdown(editNote.type) &&
            !isDriverRelease(editNote.type))
        "
      >
        {{ editNote.id ? "Update Note" : "Add Note" }}
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- Email Preview/Edit Modal -->
<p-dialog
  [(visible)]="showEmailPreview"
  [modal]="true"
  [style]="{ width: '700px', maxWidth: '95vw' }"
  header="Review Email"
  [closable]="false"
  styleClass="email-preview-dialog"
>
  <div class="modal-body">
    <div class="form-group">
      <label><strong>To:</strong></label>
      <input
        type="email"
        class="form-control email-subject"
        [ngClass]="{ 'is-invalid': emailValidationErrors.to }"
        [(ngModel)]="emailPreview.to"
        (ngModelChange)="clearEmailValidationError('to')"
      />
      <div *ngIf="emailValidationErrors.to" class="invalid-feedback d-block">
        {{ emailValidationErrors.to }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>CC:</strong></label>
      <input
        type="text"
        class="form-control email-subject"
        [ngClass]="{ 'is-invalid': emailValidationErrors.cc }"
        [(ngModel)]="emailPreview.ccEmails"
        (ngModelChange)="clearEmailValidationError('cc')"
        placeholder="Separate multiple emails with semicolons"
      />
      <div *ngIf="emailValidationErrors.cc" class="invalid-feedback d-block">
        {{ emailValidationErrors.cc }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>Subject:</strong></label>
      <input type="text" class="form-control email-subject" [(ngModel)]="emailPreview.subject" />
    </div>

    <div class="form-group">
      <label><strong>Message:</strong></label>
      <textarea class="form-control email-body" [(ngModel)]="emailPreview.body" rows="8"></textarea>
    </div>

    <!-- Quoted previous conversation (rendered like an Outlook reply; read-only) -->
    <div class="form-group" *ngIf="emailQuotedHtml">
      <label><strong>Included conversation:</strong></label>
      <div class="email-quoted-thread" [innerHTML]="emailQuotedHtml"></div>
    </div>

    <!-- Self-service signature editor (shown for every email type) -->
    <div class="form-group">
      <div class="signature-edit-row">
        <label><strong>Your email signature</strong></label>
        <button type="button" class="btn btn-link btn-sm p-0" (click)="toggleSignatureEditor()">
          {{ showSignatureEditor ? "Hide" : "Change signature" }}
        </button>
      </div>
      <div
        class="signature-preview small text-muted"
        *ngIf="!showSignatureEditor && userEmailSignature"
      >
        {{ userEmailSignature }}
      </div>
      <div *ngIf="showSignatureEditor" class="signature-editor">
        <textarea
          rows="4"
          class="form-control"
          [(ngModel)]="signatureEditText"
          placeholder="Your email signature (one line per field / company / phone)"
        ></textarea>
        <div class="signature-edit-actions">
          <button
            class="btn btn-primary btn-sm"
            (click)="saveSignature()"
            [disabled]="savingSignature"
          >
            <i class="fa fa-spin fa-spinner" *ngIf="savingSignature"></i> Save signature
          </button>
          <span class="text-muted small ml-2"
            >Saved to your profile and used on all future emails.</span
          >
        </div>
        <div
          *ngIf="signatureSaveMessage"
          class="small mt-1"
          [class.text-success]="!signatureSaveError"
          [class.text-danger]="signatureSaveError"
        >
          {{ signatureSaveMessage }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <label><strong>Attachments:</strong></label>
      <div class="attachment-upload">
        <input
          type="file"
          #fileInput
          multiple
          accept="image/*"
          (change)="onFilesSelected($event)"
          style="display: none"
        />
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fileInput.click()">
          <i class="fa fa-paperclip"></i> Add Images
        </button>
        <span class="attachment-hint">Images only (JPG, PNG, GIF)</span>
      </div>
      <div *ngIf="emailAttachments.length > 0" class="attachment-list">
        <div *ngFor="let file of emailAttachments; let i = index" class="attachment-item">
          <i class="fa fa-image"></i>
          <span class="attachment-name">{{ file.name }}</span>
          <span class="attachment-size">({{ formatFileSize(file.size) }})</span>
          <button type="button" class="btn-remove-attachment" (click)="removeAttachment(i)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="cancelEmailPreview()">Cancel</button>
      <button
        class="btn btn-primary"
        (click)="confirmSendEmail()"
        [disabled]="!emailPreview.to || !emailPreview.subject || !emailPreview.body"
      >
        <i class="fa fa-paper-plane"></i> Send Email
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- Post-create email prompt (shown by hosts after a note is created) -->
<p-dialog
  [(visible)]="showEmailPrompt"
  [modal]="true"
  [style]="{ width: '500px', maxWidth: '95vw' }"
  header="Send Notification"
  [closable]="false"
  styleClass="note-email-prompt-dialog"
>
  <div class="modal-body">
    <p *ngIf="isAccidentOrIncident(promptNoteType)">
      Would you like to email this note to safety or send the accident form to the driver?
    </p>
    <p *ngIf="isDelayOrBreakdown(promptNoteType)">
      Would you like to email the client or driver about this delay/breakdown?
    </p>
    <p *ngIf="isGeneral(promptNoteType)">
      Would you like to email the client or driver about this note?
    </p>

    <div class="button-group">
      <button
        *ngIf="isAccidentOrIncident(promptNoteType)"
        class="btn btn-info"
        (click)="emailSafetyFromPrompt()"
        [disabled]="!driver?.id || !emailFeaturesEnabled"
      >
        <i class="fa fa-envelope"></i> Email Safety
      </button>
      <button
        *ngIf="isAccidentOrIncident(promptNoteType)"
        class="btn btn-info ml-2"
        (click)="emailFormFromPrompt()"
        [disabled]="!driver?.id"
      >
        <i class="fa fa-envelope"></i> Email Form
      </button>
      <button
        *ngIf="canEmailClient(promptNoteType)"
        class="btn btn-info"
        (click)="emailClientFromPrompt()"
        [disabled]="!driver?.id || !emailFeaturesEnabled"
      >
        <i class="fa fa-envelope"></i> Email Client
      </button>
      <button
        *ngIf="canEmailDriver(promptNoteType)"
        class="btn btn-info ml-2"
        (click)="emailDriverFromPrompt()"
        [disabled]="!driver?.id"
      >
        <i class="fa fa-envelope"></i> Email Driver
      </button>
    </div>
  </div>
  <p-footer>
    <button class="btn btn-secondary" (click)="closeEmailPrompt()">Done</button>
  </p-footer>
</p-dialog>
